export class MAP {
    [key: string]: any;
}

export class DataRequestOptions {

    anonymous: boolean;
    token: string;
    lockOnce: string;  // must be '1'

    constructor(anonymous: boolean, token?: string, lockOnce?: string) {
        this.anonymous = anonymous;
        this.token = token;
        this.lockOnce = lockOnce;
    }
}

export class PollInfoRecord {
// 23 fields

    pollId: number;

    pollTitle: string;
    preText: string;
    postText: string;
    topgifUrl: string;
    endpollUrl: string;
    customPollUrl: string;
    styleSheetUrl: string;

    questSetNums: number;   // number of quest sets for particular pollId and scriptId

    timeLimit: number;

    anonymity: number;

    resultsAvailableFlag: boolean;         // taker can see poll results
    mustAnswerAllFlag: boolean;            // taker must answer all questions
    multipleResponsesFlag: boolean;        // taker can take poll more than one time
    selfTestFlag: boolean;                 // means taker can see answers after poll submission
    pollResponseEditableFlag: boolean;     // taker can redo poll by updating its responses
    hasCorrectAnswersFlag: boolean;        // poll provides correct answers
    previewResponsesFlag: boolean;         // poll taker submits responses in preview page

    openDate: string;                      // date string
    closeDate: string;                     // date string
    resultsDate: string;                   // date string

    themeTypeCode: string;                 // theme type attached to poll
    ownerAuthorRole: boolean;                // poll owner has "Author" role

}

export declare type TakerKind =
    'taker|edit'        // full taker edit (enter values)
    | 'taker|view'     // taker view (without actions)
    | 'author|edit'     // full author edit UI and behavior
    | 'author|edit|disabled' // full author edit in disabled mode
    | 'author|view'   // author without actions, e.g. 'view poll results'
    ;

// Using to pass options to components that are really needed instead whole poll, etc
export class PollOptions {

    takerKind: TakerKind;                  // see TakerKind
    pollId: number;
    questSetNums: number;                  // number of quest sets for the current pollId and scriptId
    mustAnswerAllFlag: boolean;            // taker must answer all questions
    hasCorrectAnswersFlag: boolean;        // poll provides correct answers
    previewResponsesFlag: boolean;         // poll taker submits responses in preview page
    pollTitle?: string;                    // used in dialogs instead of pollId (optional)
    postText?: string;                     // used in questions edit, etc (optional)
    anonymousUser?: boolean;               // used in TakerPrivacyComponent (optional)
    vars?: any;                            // passing variables to components. vars must not be null for sighed user.
    ownerAuthorRole?: boolean;             // required by some components

    constructor(takerKind: TakerKind, pollId?: number, questSetNums?: number, mustAnswerAllFlag?: boolean, hasCorrectAnswersFlag?: boolean,
                previewResponsesFlag?: boolean, pollTitle?: string, postText?: string, anonymousUser?: boolean,
                vars?: any, ownerAuthorRole?: boolean) {
        this.takerKind = takerKind;
        this.pollId = pollId;
        this.questSetNums = questSetNums;
        this.mustAnswerAllFlag = mustAnswerAllFlag;
        this.hasCorrectAnswersFlag = hasCorrectAnswersFlag;
        this.previewResponsesFlag = previewResponsesFlag;
        this.pollTitle = pollTitle;
        this.postText = postText;
        this.anonymousUser = anonymousUser;
        this.vars = vars || {};
        this.ownerAuthorRole = ownerAuthorRole;
    }
}

export class SubquestionResponse {
    choiceNums: number[];
    value: string;
    shortText: string;
}

export class TakerResultsSummary {
    correctAnswersNum: number;      // number of correct graded answers or null if N/A
    gradedQuestionsNum: number;     // total number of graded questions or null if N/A

    correctSubAnswersNum: number;   // number of correct graded subquestion answers or null if N/A
    gradedSubquestionsNum: number;  // total number of graded subquestions or null if N/A

    questions: MAP;                 // True/False responses to questions
}

export class SubquestionResponseMap {
    [key: string]: SubquestionResponse;
}

export class PollResultRecord {
    questNum: number;
    subquestNum: number;
    choiceNum: number;

    questTypeCode: string;

    min: number;
    max: number;
    average: number;
    sum: number;

    responseCount: number;
    shortTextCount: number;
}

export class SubmittedResponses {
    constructor(public obj: any) {
        ;
    }
}

